import { type SbBlokData, storyblokEditable } from "@storyblok/react/rsc";
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/Accordion";
import { RichTextRender } from "@/components/ui/RichText";
import type { AccordionitemStoryblok } from "@/generated/sb/sb-types";
import styles from "./index.module.css";

const AccordionItemBlok = ({
  item,
  preview,
  open,
}: {
  item: AccordionitemStoryblok;
  preview: boolean;
  open?: boolean;
}) => {
  return (
    <AccordionItem
      {...storyblokEditable(item as unknown as SbBlokData)}
      open={open}
    >
      <AccordionTrigger>{item.title}</AccordionTrigger>
      <AccordionContent>
        {item.text && (
          <div className={`${styles.accordionitem__body}`}>
            <RichTextRender blok={item.text} preview={preview} />
          </div>
        )}
      </AccordionContent>
    </AccordionItem>
  );
};

export default AccordionItemBlok;
